module.exports = __webpack_public_path__ + "static/stardust-flex-mixed-align-63dbf33ab6956edb315fab7808624f8a.png";